import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

export default function CheckoutCancel() {
    const { t } = useTranslation();
    return (
        <div data-testid="checkout-cancel-page" className="pt-32 min-h-[70vh]">
            <section className="container-rail max-w-2xl mx-auto py-16 text-center space-y-8">
                <div className="text-overline text-[#A3A3A3]">{t("checkout_cancel.label")}</div>
                <h1 className="text-display text-5xl sm:text-6xl leading-tight">
                    {t("checkout_cancel.title_1")} <span className="text-display-italic">{t("checkout_cancel.title_italic")}</span>
                </h1>
                <p className="text-[#A3A3A3] max-w-md mx-auto">
                    {t("checkout_cancel.body")}
                </p>
                <Link to="/shop" className="btn-primary inline-flex" data-testid="cancel-return">
                    <ArrowLeft className="h-4 w-4" /> {t("checkout_cancel.continue")}
                </Link>
            </section>
        </div>
    );
}
